import { AppliedPromotionStatus } from '../../../../../../types/AppPromotions';
import { AppliedPromotionsFiltersMap } from './AppliedPromotionsFilters';
const applyBillingFilter = promotions => promotions.filter(promotion => promotion.status === AppliedPromotionStatus.ACTIVE && promotion.totalBillingCycles - promotion.completedBillingCycles > 0);
const applyStatusFilter = (promotions, value) => promotions.filter(promotion => promotion.status === value);
export const applyFilters = (promotions, filters) => {
  if (filters.length === 0) {
    return promotions;
  }
  filters.forEach(filterBy => {
    if (filterBy.type === AppliedPromotionsFiltersMap.BILLING_CYCLE) {
      promotions = applyBillingFilter(promotions);
    }
    if (filterBy.type === AppliedPromotionsFiltersMap.STATUS) {
      promotions = applyStatusFilter(promotions, filterBy.value);
    }
  });
  return promotions;
};